// Hostnames where third-party auth services (Google OAuth redirect URIs,
// reCAPTCHA site key) are pre-registered. Both services reject requests from
// any other origin, so gating their UI by hostname avoids showing widgets that
// can't possibly work. Adding a hostname here requires also registering it with
// Google Cloud Console + reCAPTCHA admin — do not loosen this check otherwise.
const EXTERNAL_AUTH_HOSTNAMES = [
  'app.flowbookings.io',
  'staging-app.flowbookings.io',
];

export default function isExternalAuthHostname() {
  return EXTERNAL_AUTH_HOSTNAMES.includes(window.location.hostname);
}
